export const enum NordicNestContentVerticalAlignment {
  Top = 'flex-start',
  Center = 'center',
  Bottom = 'flex-end',
}

export function mapContentVerticalAlignment(ContentVerticalAlignment: NordicNest.Api.ContentVerticalAlignment) {
  switch (ContentVerticalAlignment) {
    case 'top':
      return NordicNestContentVerticalAlignment.Top;
    case 'center':
      return NordicNestContentVerticalAlignment.Center;
    case 'bottom':
      return NordicNestContentVerticalAlignment.Bottom;
    default:
      return NordicNestContentVerticalAlignment.Bottom;
  }
}

export const enum NordicNestContentHorizontalAlignment {
  Left = 'flex-start',
  Center = 'center',
  Right = 'flex-end',
}

export function mapContentHorizontalAlignment(ContentHorizontalAlignment: NordicNest.Api.ContentHorizontalAlignment) {
  switch (ContentHorizontalAlignment) {
    case 'left':
      return NordicNestContentHorizontalAlignment.Left;
    case 'center':
      return NordicNestContentHorizontalAlignment.Center;
    case 'right':
      return NordicNestContentHorizontalAlignment.Right;
    default:
      return NordicNestContentHorizontalAlignment.Left;
  }
}
